import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatOptionModule } from '@angular/material/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { LocationManagerEffects } from '../../store/location-manager/location-manager.effects';
import { locationManagerReducer, initialState } from '../../store/location-manager/location-manager.reducer';
import { RequiresPermissionsModule } from '../directives';
import { GenericAutocompleteResultsModule } from '../generic-autocomplete-results';
import { GenericSearchModule } from '../generic-search';
import { LocationManagerMapComponent } from './location-manager-map/location-manager-map.component';
import { LocationManagerPageComponent } from './location-manager-page/location-manager-page.component';
import { LocationComponent } from './location/location.component';
import { clearState } from '../../app/store/clear-state.reducer';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    StoreModule.forFeature('locationManager', locationManagerReducer, {
      initialState: initialState,
      metaReducers: [clearState]
    }),
    EffectsModule.forFeature([LocationManagerEffects]),
    MatCardModule,
    MatInputModule,
    MatButtonModule,
    MatRadioModule,
    MatIconModule,
    MatOptionModule,
    MatListModule,
    MatDividerModule,
    MatSlideToggleModule,
    MatProgressSpinnerModule,
    GenericSearchModule,
    GenericAutocompleteResultsModule,
    RequiresPermissionsModule
  ],
  declarations: [LocationManagerMapComponent, LocationManagerPageComponent, LocationComponent],
  exports: [LocationManagerMapComponent, LocationManagerPageComponent, LocationComponent]
})
export class LocationManagerModule {}
